import React from 'react';
import BottomNav from './BottomNav';
import { useCart } from '../contexts/CartContext';
import { ShoppingCart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function GuestLayout({ children }) {
  const { itemCount } = useCart();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-bone">
      {itemCount > 0 && (
        <button
          onClick={() => navigate('/cart')}
          data-testid="floating-cart-btn"
          className="fixed top-5 right-5 z-50 bg-espresso text-white rounded-full w-12 h-12 flex items-center justify-center shadow-[0_8px_30px_-12px_rgba(44,42,38,0.25)] transition-transform active:scale-95"
        >
          <ShoppingCart size={20} />
          <span className="absolute -top-1 -right-1 bg-warmgold text-espresso text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center">
            {itemCount}
          </span>
        </button>
      )}
      <main className="pb-24">{children}</main>
      <BottomNav />
    </div>
  );
}
